﻿$.fn.dxCtrlContentEnvoiMailingDe = function custom_dxCtrlContentEnvoiMailingDe(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentenvoimailingde dx-ctrl");
        this.createInstance(new cdxCtrlContentEnvoiMailingDe(this, option));
    }
    return this;
}

window.cdxCtrlContentEnvoiMailingDe = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var jauge = null
    function mConstruit() {
        container.empty()
        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        switch (option.type) {
            case "email":
                //saisie adresse email + dns
                var $Div = $("<div/>").appendTo(container)
                var dxNomUsuel = $("<div/>").appendTo($Div).dxCtrlTextBox({
                    labelMode: 'floating',
                    label: "Nom usuel",
                    text: option.data.nom_usuel_expediteur,
                    onValueChanged: function (e) {
                        option.data.nom_usuel_expediteur = ((e.value == null) ? "" : e.value)
                        option.bddCtrl.getObjet(option.data).mSaveChamp("nom_usuel_expediteur")
                        option.onChange()
                    }
                })
                $("<div style='font-size:85%;margin:10px 30px 0 30px;'>Nom d’envoi que votre correspondant verra lorsque le mail arrivera en boîte de réception.</div>").appendTo($Div)
                $("<div style='font-size:85%;margin:0px 30px;'>Nous vous recommandons d'utiliser un nom que vos correspondants reconnaîtront instantanément, comme le nom de votre entreprise.</div>").appendTo($Div)

                var dataCompteEmail = null
                if (option.data.id_compte_email != null) {
                    dataCompteEmail = option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetLstDataCompteEmail().filter(function (dataCpteEmail) {
                        return dataCpteEmail.id_compte_email == option.data.id_compte_email
                    })[0]
                }
                var $Div = $("<div style='margin-top:30px;'/>").appendTo(container)
                if (parametre.baseAppli.para.email.create_adresse_email_dans_emailing) {
                    //on peut créer directement une nouvelle adresse email dans la liste (quickmailing)
                    var $DivSelectEmail = $("<div/>").appendTo($Div)
                    mRempliLstEmail()
                    function mRempliLstEmail() {
                        $DivSelectEmail.empty()
                        var lstEmail = [null]
                        var cptEmail = null
                        option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetLstDataCompteEmail().sort(function (o1, o2) { return (o1.adresse_email).localeCompare(o2.adresse_email) }).forEach(function (dataCompteEmail) {
                            lstEmail.push(dataCompteEmail)
                            if (option.data.email_expediteur == dataCompteEmail.adresse_email) cptEmail = dataCompteEmail
                        })
                        var disableOnValueChanged = false
                        var dxSelectEmail = $("<div/>").appendTo($DivSelectEmail).dxSelectBox({
                            labelMode: 'floating',
                            label: "Expéditeur",
                            noDataText: "Aucune adresse email disponible... Veuillez en saisir une nouvelle...",
                            dataSource: lstEmail,
                            value: cptEmail,
                            displayExpr: "adresse_email",
                            itemTemplate: function (itemData, itemIndex, itemElement) {
                                if (itemData == null) {
                                    itemElement.css({ "font-style": "italic","font-weight":"bold" })
                                    itemElement.text("<Ajouter une nouvelle adresse email>")
                                } else {
                                    itemElement.text(itemData.adresse_email)
                                }
                            },
                            onValueChanged: function (e) {
                                if (disableOnValueChanged) return
                                if (e.value == null) {
                                    //on demande la création d'un nouveau email
                                    var dxSaisieNewEmail = null
                                    mConfirmPopup(function (contentEle, pop) {
                                        dxSaisieNewEmail = $("<div/>").appendTo(contentEle).dxCtrlTextEmail({
                                            label: "Saisir une nouvelle adresse email",
                                            labelMode: 'floating',
                                        }).dxCtrlTextEmail("instance")
                                        window.setTimeout(function () { dxSaisieNewEmail.focus() }, 1000)
                                    }, function (pop) { //confirm
                                        if (dxSaisieNewEmail.option("value") == null || dxSaisieNewEmail.option("value").length == 0) {
                                            mNotify("Veuillez saisir une adresse email", "warning", 6000)
                                            return false
                                        }
                                        if (lstEmail.contains(dxSaisieNewEmail.option("value"))) {
                                            mNotify("Cette adresse email existe déjà", "warning", 6000)
                                            return false
                                        }
                                        $("<div/>").appendTo("body").dxCtrlSaisieCode({
                                            bddCtrl: option.bddCtrl,
                                            title: "Confirmez votre email",
                                            adresse_email: dxSaisieNewEmail.option("value"),
                                            from: "Ajout adresse email from envoi mailing (De) (dxCtrlContentEnvoiMailingDe)",
                                            onValide: function () {
                                                //on crée le mail dans la base
                                                jaugeDemarrage.mShow()
                                                option.bddCtrl.mAjaxCall({
                                                    command: "create_compte_email",
                                                    adresse_email: dxSaisieNewEmail.option("value"),
                                                    id_utilisateur: option.bddCtrl.utiCourant.id_utilisateur
                                                }, function (data) {
                                                    option.bddCtrl.mReloadTable(["compte_email", "compte_email_utilisateur"], function () {
                                                        mRempliLstEmail()
                                                        var lstEmail2 = [null]
                                                        var cptEmail2 = null
                                                        option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetLstDataCompteEmail().sort(function (o1, o2) { return (o1.adresse_email).localeCompare(o2.adresse_email) })
                                                            .forEach(function (dataCompteEmail) {
                                                                lstEmail2.push(dataCompteEmail)
                                                                if (dataCompteEmail.adresse_email == dxSaisieNewEmail.option("value")) cptEmail2 = dataCompteEmail
                                                            })
                                                        option.data.id_compte_email = cptEmail2.id_compte_email
                                                        option.data.email_expediteur = cptEmail2.adresse_email
                                                        option.bddCtrl.getObjet(option.data).mSave()
                                                        dxConfDns.option("adresse_email", option.data.email_expediteur)
                                                        option.onChange()
                                                        dxConfDns.mReload()
                                                        mRempliLstEmail()
                                                        jaugeDemarrage.mHide()
                                                        pop.hide()
                                                    })
                                                })
                                                //dxSelectEamil.option("value", dxSaisieNewEmail.option("value"))
                                            },
                                            onCancel: function () {
                                                //pop.hide()
                                            }
                                        })
                                        return false
                                    }, "Créer le mail", function () { }, "Annuler", null, showTitle = true)
                                    window.setTimeout(function () {
                                        disableOnValueChanged = true
                                        e.component.option("value", e.previousValue)
                                        disableOnValueChanged = false
                                    }, 0)
                                } else {
                                    option.data.id_compte_email = e.value.id_compte_email
                                    option.data.email_expediteur = e.value.adresse_email
                                    option.bddCtrl.getObjet(option.data).mSave()
                                    dxConfDns.option("adresse_email", option.data.email_expediteur)
                                    option.onChange()
                                    dxConfDns.mReload()
                                }
                            }
                        }).dxSelectBox("instance")
                    }
                } else {
                    var dxCtrlEmailExp = $("<div/>").appendTo($Div).dxCtrlSelectBoxCompteEmail({
                        bddCtrl: option.bddCtrl,
                        readOnly: false,
                        value: dataCompteEmail,
                        onValueChanged: function (e) {
                            option.data.id_compte_email = e.value.id_compte_email
                            option.data.email_expediteur = e.value.adresse_email
                            option.bddCtrl.getObjet(option.data).mSave()
                            dxConfDns.option("adresse_email", option.data.email_expediteur)
                            option.onChange()
                            dxConfDns.mReload()
                        }
                    }).dxCtrlSelectBoxCompteEmail("instance")
                }

                var dxConfDns = $("<div style='margin:20px 30px 15px 30px;min-height:55px;font-size:85%;'/>").appendTo($Div).dxCtrlCompteEmailConfigEnvoiDns({
                    bddCtrl: option.bddCtrl,
                    adresse_email: option.data.email_expediteur,
                    showDelivrabilite: false,
                    allowSave:true
                }).dxCtrlCompteEmailConfigEnvoiDns("instance")

                if (option.bddCtrl.objCptCli.data.multi_societe == "1") {
                    $("<div/>").appendTo($Div).dxSelectBox({
                        label: "Société",
                        labelMode: 'floating',
                        width: "100%",
                        dataSource: option.bddCtrl.mGetArray("societe").filter(function (o) { return o.date_abandon == null }),
                        value: option.data.id_societe,
                        displayExpr: "nom",
                        displayValue: "nom",
                        valueExpr: "id_societe",
                        onValueChanged: function (e) {
                            option.data.id_societe = e.value
                            option.bddCtrl.getObjet(option.data).mSaveChamp("id_societe")
                        }
                    })
                }
                break;
            case "sms":
                //saisie emetteur
                if (option.data.emetteur == null || option.data.emetteur.length == 0) option.data.emetteur = option.bddCtrl.paraAppli.mGetPara("sms_emetteur")
                $("<div style='margin-bottom:15px;'/>").appendTo(container).dxCtrlSaisieEmetteurSms({
                    bddCtrl: option.bddCtrl,
                    afficheAide: true,
                    value: option.data.emetteur,
                    onValueChanged: function (e) {
                        option.data.emetteur = e.value.toUpperCase()
                        option.bddCtrl.getObjet(option.data).mSaveChamp("emetteur", function () {
                            option.onChange()
                        })
                    }
                })
                break;
        }
    }

    this.element = function () { return container }

    mConstruit();
}